<template>
  <v-row wrap justify="center">
    <v-col cols="12" md="8" class="pt-0">
       <template v-if="client && client.primaryContact">
          <Contact :contact="client.primaryContact" />
        </template>
    </v-col>
    <v-col cols="12" md="8" class="pt-0">
      <template v-if="client && client.mailingAddress">
          <Address :address="client.mailingAddress" />
      </template>
      <template v-else>
          <span>No Mailing Address</span>
      </template>
    </v-col>

    <v-col v-for="(item, idx) in navItems" :key="idx" cols="12" md="8" class="py-1">
      <v-card color="blue5" :disabled="item.disabled" @click="handleCardClick(item.route)">
        <v-card-title>
          {{ item.title }}
          <v-spacer />
          <v-icon color="blue3">{{ item.icon }}</v-icon>
        </v-card-title>
        <v-card-subtitle>
          {{ item.description }}
        </v-card-subtitle>
      </v-card>
    </v-col>
  </v-row>
</template>

<style>
</style>

<script>
import { mapState } from 'vuex';
import Address from '@/components/Client/Address.vue';
import Contact from '@/components/Client/Contact.vue';

export default {
  components: {
    Address,
    Contact
  },
  data: function () {
    return {
      navItems: [
        {
          title: 'Contact Information',
          icon: 'mdi-contacts',
          description: 'Contact information for this client',
          route: '/contacts'
        },
        {
          title: 'People',
          icon: 'mdi-account-card-details',
          description: 'People insured by this client',
          route: '/profiles'
        },
        {
          title: 'Policies',
          icon: 'mdi-file-document',
          description: 'Policies associated with this client',
          route: '/policies'
        }

      ]
    };
  },
  computed: {
    ...mapState(['client']),
    personalProfiles: function () {
      if ((this.client || null) === null || (this.client.personalProfiles || null) === null) return [];
      return this.client.personalProfiles;
    }
  },
  methods: {
    handleCardClick: function (route) {
      if ((route || null) === null) return;
      if (route === '') return;

      this.$router.push(this.$route.path + route);
    }
  }
};
</script>
